module.exports = __webpack_public_path__ + "static/video_wall-a7799f7bdf8f7a66f6305f02a5f4a473.mp4";